import { Badge } from '@/components/ui/badge';
import DataTable from '@/components/ui/data-table/index';
import { useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';
import {  CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { useParams } from 'react-router-dom';
import { Box, Package, TrendingUp } from 'lucide-react';
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "@/components/ui/pagination";
import { useQuery } from '@tanstack/react-query';
import {  AlertDescription } from '@/components/ui/alert';
import { Skeleton } from '@/components/ui/skeleton';
import { reportApi } from '@/services/api/reports';
import { searchToolApi } from '@/services/api/searchTool';
import type { Report } from '@/services/api/reports';
import type { SearchToolResponse, FieldItem } from '@/services/api/searchTool';
import DynamicTsxRenderer from '@/components/DynamicTsxRenderer';
import dayjs from 'dayjs';
import { 
  Card, 
  Table, 
  Input, 
  Select, 
  Button, 
  DatePicker, 
  Checkbox,
  Space,
  Spin,
  Alert,
  Empty,
  Statistic,
  Layout,
  Row,
  Col
} from 'antd';
import { 
  SearchOutlined, 
  ReloadOutlined,
  BarChartOutlined,
  BoxPlotOutlined
} from '@ant-design/icons';

// 定义表格数据类型
type TableDataType = Record<string, unknown>;

interface Column {
  accessorKey: string;
  header: string;
}

export default function ReportPage() {
  const { searchId } = useParams<{ searchId: string }>();
  const [columns, setColumns] = useState<Column[]>([]);
  const [, setChartInstance] = useState<echarts.ECharts | null>(null);
  const [reportName, setReportName] = useState<string>('');
  const [isDynamicTsx, setIsDynamicTsx] = useState<boolean>(false);
  const [tsxCode, setTsxCode] = useState<string>('');
  const [key,setKey] = useState<string>('');

  
  // 获取报表配置
  const { 
    data: reportConfig
  } = useQuery<Report[]>({
    queryKey: ['reports', searchId],
    queryFn: () => reportApi.getReportData({ page_size: 50, page_no: 1, searchId: Number(searchId) || null }),
    enabled: !!searchId,
    staleTime: 0, // 确保每次都获取最新数据
    gcTime: 0, // 不缓存数据
  });


  // 检查是否为动态 TSX 类型的报表
  useEffect(() => {
    if (!reportConfig || !Array.isArray(reportConfig) || reportConfig.length === 0) return;
    
    const report = reportConfig[0];
    if (report?.option_json) {
      try {
        // 检查 option_json 是否包含 TSX 代码
        if ((report.option_json.includes('tsx') || report.option_json.includes('function'))) {
          setIsDynamicTsx(true);
          // mock一个简单的react页面代码
          setTsxCode(report.option_json);
          setKey(report.update_time)
          setReportName(report.name || '动态报表');
          return; // 如果是动态TSX，直接返回，不需要初始化图表
        } else {
          setIsDynamicTsx(false);
        }
      } catch (error) {
        console.error('检查报表类型失败:', error);
        setIsDynamicTsx(false);
      }
    }
  
  }, [reportConfig, isDynamicTsx]);

  // 如果是动态 TSX 类型，直接渲染动态组件
  if (isDynamicTsx && tsxCode) {
    console.log('isDynamicTsx',isDynamicTsx);
    return (
        <DynamicTsxRenderer 
          key={key}   // 使用tsxCode作为key，当tsxCode变化时，组件会重新挂载
          tsxCode={tsxCode} 
          searchId={searchId}
        />
    );
  }
  return (
    <div>
       <DynamicTsxRenderer 
          key={key}   // 使用tsxCode作为key，当tsxCode变化时，组件会重新挂载
          tsxCode={tsxCode} 
          searchId={searchId}
        />
    </div>
  );
}